import TutorialPage from "./tutorial-page"

export const OfficeStudentTutorialPage = () => {


    return (
        <TutorialPage variant='office-student'/>
    )

}